var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 17.848 17.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(17.848 17.848) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5218",
    "data-name": "Group 5218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5217",
    "data-name": "Group 5217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4950",
    "data-name": "Path 4950",
    d: "M8.924,0a8.924,8.924,0,1,0,8.924,8.924A8.919,8.919,0,0,0,8.924,0Zm0,16.6A7.679,7.679,0,1,1,16.6,8.924,7.687,7.687,0,0,1,8.924,16.6Z",
    fill: "#FF5757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5220",
    "data-name": "Group 5220",
    transform: "translate(8.02 7.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5219",
    "data-name": "Group 5219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4951",
    "data-name": "Path 4951",
    d: "M230.963,213.4c-.529,0-.9.223-.9.552v4.475c0,.282.376.564.9.564.505,0,.916-.282.916-.564v-4.475C231.88,213.62,231.469,213.4,230.963,213.4Z",
    transform: "translate(-230.059 -213.397)",
    fill: "#FF5757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5222",
    "data-name": "Group 5222",
    transform: "translate(7.961 4.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5221",
    "data-name": "Group 5221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4952",
    "data-name": "Path 4952",
    d: "M229.338,134.208a.846.846,0,1,0,.952.834A.91.91,0,0,0,229.338,134.208Z",
    transform: "translate(-228.375 -134.208)",
    fill: "#FF5757"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f0cce42c7d02a8fcebc6be310cec8894.svg";
export { ForwardRef as ReactComponent };